module.exports = __webpack_public_path__ + "96697c7fafb1a101df9e17d0ef648d12.MP3";